module.exports = __webpack_public_path__ + "static/media/clock.70efd50c.svg";